import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=234d1281&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"
import style0 from "./alert.vue?vue&type=style&index=0&id=234d1281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234d1281",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234d1281')) {
      api.createRecord('234d1281', component.options)
    } else {
      api.reload('234d1281', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=234d1281&scoped=true&", function () {
      api.rerender('234d1281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/alert.vue"
export default component.exports